import { useState, useEffect } from 'react';
import { useTracking } from "react-tracking";
import toast from 'react-hot-toast';
import { Container, TextField, Alert, Pagination, Grid, InputAdornment, Button, Modal, Fade, Box, Typography } from '@mui/material';
// components
import Page from '../components/Page';
import Loader from "./Loader";
import { DashboardSort, DashboardList } from '../components/_dashboard/dashCards'
import Controls from '../components/controls/Controls'
//Data
import { getDashboardList, changeStatus, deleteDashboard, updateDashboard } from '../config/services/dashboards';
import { validateUserRole } from '../config/services/role';
import { markDashboardFavourite } from '../config/services/users';
// ----------------------------------------------------------------------
import SearchIcon from '../assets/icons/icon_search.svg';
import Popup from '../components/Popup';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import ErrorOutlineSharpIcon from '@mui/icons-material/ErrorOutlineSharp';

export default function DashboardApp(props) {
  const queryParams = useLocation().search;
  let currentPage = new URLSearchParams(queryParams).get('pageNo');
  //console.log(currentPage)
  const [dashboardList, setDashboardList] = useState([]);
  const [dashboardsTotalCount, setDashboardTotalCount] = useState(0)
  const [search, setSearchValue] = useState('')
  const [sortObj, setSortObj] = useState({ sortKey: 'createdAt', sortOrder: '-1' })
  const [loader, setLoading] = useState(false)
  const [pageNo, setPagination] = useState(currentPage ? currentPage === 'null' ? 1 : parseInt(currentPage) : 1)
  const [itemsPerPage, setItemsPerPage] = useState(8)
  const [deleteObj, setDeleteObj] = useState({ dashboardId: '', dashboardName: '' })
  const [deletePopup, setDeletePopup] = useState(false)
  const [restrictOption, setRestrictOption] = useState(false)
  const [userTypeList, setUserTypeList] = useState([])
  const { trackEvent } = useTracking()
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate();

  let totalPages = Number((dashboardsTotalCount / itemsPerPage).toFixed(0))

  const handleSearch = (e) => {
    let { value } = e.target
    setPagination(1)
    setSearchValue(value)
    trackEvent({ Component: 'DashboardApp', event: "SearchDashboard", funcName: 'handleSearch', value })
  }

  const handleSort = (params) => {
    let { sortOrder, sortKey } = params
    setSortObj({ sortKey, sortOrder })
    trackEvent({ Component: 'DashboardApp', event: "SortDashboardListing", funcName: 'handleSort', params })
  }

  const handlePagination = (e, pageNumber) => {
    setPagination(pageNumber)
    setSearchParams({ pageNo: pageNumber })
  }

  const fetchDashboardList = async () => {
    let params = { pageNo: (pageNo) - 1, count: itemsPerPage, search, ...sortObj }
    if (props?.favouriteFilter === true) {
      params.favouriteFilter = true
    }
    setLoading(true)
    let response = await getDashboardList(params)

    if (!response?.result?.length && params.pageNo > 0) {
      handlePagination({}, params.pageNo)
      params.pageNo = params.pageNo - 1
      response = await getDashboardList(params)
      setLoading(false)
    }

    if (response?.result) {
      setDashboardList(response?.result);
      setDashboardTotalCount(response?.totalCount)
      setLoading(false)
    }
  }

  const handleDeleteDashboard = async (params) => {
    setDeleteObj({ dashboardId: params?._id, dashboardName: params?.dashboardName })
    setDeletePopup(true)
    trackEvent({ Component: 'DashboardApp', event: "DeleteDashboardBtnClick", funcName: 'handleDeleteDashboard', params: { dashboardId: params?._id, dashboardName: params?.dashboardName } })
  }

  const handleCancelDelete = () => {
    setDeletePopup(false)
    setDeleteObj({})
  }


  const submitDeleteDashboard = () => {
    let { dashboardId } = deleteObj
    deleteDashboard({ dashboardId })
      .then(res => {
        let trackEventObj = {
          Component: 'DashboardApp',
          event: "DeleteDashboardConfirm",
          funcName: 'submitDeleteDashboard',
          params: deleteObj,
          response: res
        }

        if (res?.result) {
          handleCancelDelete()
          fetchDashboardList()
          toast.success(res?.message)
          trackEventObj.success = true
        }
        else if (res?.data?.statusCode === 0) {
          toast.error(res?.data?.error?.errorMessage)
          setLoading(false)
          trackEventObj.error = true
        }

        trackEvent(trackEventObj)
      })
  }

  const handleShareDashboard = async (params, setOpenSharePopup, setShareProps) => {
    const resp = await updateDashboard(params)
    toast.success(resp.message)
    setShareProps({ props: {} })
    setOpenSharePopup(false)
    fetchDashboardList()
    trackEvent({ Component: 'DashboardApp', event: "ShareDashboard", funcName: 'handleShareDashboard', params })
  }


  const handleFavrtDashboard = (params) => {
    let reqParams = { dashboardId: params._id, isFavourite: params.isFavourite }
    trackEvent({ Component: 'DashboardApp', event: "MarkFavrtDashboard", funcName: 'handleFavrtDashboard', params: reqParams })

    setLoading(true)
    markDashboardFavourite(reqParams)
      .then((res) => {
        fetchDashboardList()
        toast.success(res.message)
      });
  }


  const handleDeactivateDashboard = (e, params) => {
    let { checked } = e.target
    let reqParams = { dashboardId: params._id, isDeactivated: !checked }
    trackEvent({ Component: 'DashboardApp', event: "DeactivateDashboard", funcName: 'handleDeactivateDashboard', params: reqParams })

    setLoading(true)
    changeStatus(reqParams)
      .then((res) => {
        fetchDashboardList()
        toast.success(res.message)
      })
  }
  useEffect(async () => {
    const res = await validateUserRole({ populateDeep: true });
    if (res) {
      const selectedUserList = res?.userType[0]?.userTypeList ? res?.userType[0]?.userTypeList : []
      setUserTypeList(selectedUserList)
    }
  }, [])
  useEffect(() => fetchDashboardList(), [search, sortObj, pageNo, itemsPerPage, currentPage]);

 

  const handleDashboardAccess = (redirect = null) => {
    if (window.innerWidth > 900 && redirect) {
      window.open(redirect, "_self")
      trackEvent({ Component: 'DashboardApp', event: "EditDashboard", funcName: 'handleDeactivateDashboard', params: { redirect } })
    } else {
      setRestrictOption(true);
    }
  }

  return (
    <Page title="Extramarks | Report-Engine" className="main-container">
      <Container className="table_max_width">
        <Grid container alignItems="left" className="dashboard-header" justifyContent="flex-start" mb={2} spacing={2.5}>
          <Grid item md={6} sm={4} xs={12}>
            <TextField fullWidth className={`report_form_ui_input pl-0`} type="search"
              placeholder="Search By Dashboard Name"
              onChange={handleSearch}
              InputLabelProps={{ style: { ...({ top: `${-7}px` }) } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={SearchIcon} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item md={props?.favouriteFilter === true ? 6 : 3} sm={4} xs={12} >
            <DashboardSort className="report_form_ui_input_select" handleSort={handleSort} />
          </Grid>

          {props?.favouriteFilter === true ? null :
            <Grid item md={3} sm={4} xs={12}>
              <Controls.Button className="cm_ui_button" text="Create New Dashboard" variant="contained" onClick={() => handleDashboardAccess("/reportDashboard/new")} />
            </Grid>}
        </Grid>


        {loader && <Loader />}

        {dashboardList?.length ?
          <DashboardList dashboards={dashboardList} handleFavrtDashboard={handleFavrtDashboard} handleDeactivateDashboard={handleDeactivateDashboard}
            handleDeleteDashboard={handleDeleteDashboard} handleShareDashboard={handleShareDashboard} handleEditDashboard={handleDashboardAccess} userTypeList={userTypeList} pageNo={pageNo} />
          : <Alert severity="error">No Content Available!</Alert>}

      </Container>

      {
        dashboardList?.length ?
          <div className='center cm_pagination'>
            <Pagination
              count={Math.ceil(Number((dashboardsTotalCount / itemsPerPage)))}
              variant="outlined"
              color="primary"
              onChange={handlePagination}
              page={currentPage ? parseInt(currentPage) : pageNo} />
          </div>
          : null
      }

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modal-root"
        open={deletePopup}
        closeAfterTransition
      >
        <Fade in={deletePopup}>
          <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
            <Box className="modal-content-simple">
              <Typography variant="subtitle1" className="modal-heading-title-simple">{`Are you sure to delete this Dashboard "${deleteObj?.dashboardName}" ?`}</Typography>
              <Box className="modal-footer-simple">
                <Button onClick={handleCancelDelete} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </Button>
                <Button onClick={submitDeleteDashboard} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> Delete </Button>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modal-root"
        open={restrictOption}
        onClose={() => setRestrictOption(false)}
        closeAfterTransition
      >
        <Fade in={restrictOption}>
          <Box className="modal-paper modal-box modal-xs" id="transition-modal-title">
            <Box className="modal-content-simple text-center" sx={{ p: '1rem !important' }}>
              <ErrorOutlineSharpIcon color="primary" />
              <Typography variant="subtitle1" className="text-plain font-weight-normal">To use Custom Reports Feature, Switch to Desktop screen</Typography>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </Page>
  );
}
